<template>
  <draggable
    :class="fullWidth ? 'draggable-chip--is-full-width' : 'draggable-chip--is-inline'"
    :id="id"
    :list="value"
    v-bind="dragOptionsChips"
    :move="move"
    @change="change"
    class="draggable-chip"
  >
    <v-chip :key="id" draggable close @mousedown.stop @click.stop @input="() => onChipDeleteClick(id)" class="draggable-chip__v-chip">
      <div class="draggable-chip__content">
        <span v-if="filterType" class="draggable-chip__prepend">
          <UiIcon v-if="filterType === 'multiple'" icon="im-square-stack-lucide" />
          <UiIcon v-else-if="filterType === 'range'" icon="im-sliders-horizontal-phosphor" />
        </span>

        <span class="draggable-chip__label"> <slot /> </span>

        <span v-if="hasSettings" class="draggable-chip__append">
          <el-popover
            v-if="hasSettings"
            trigger="click"
            placement="bottom-end"
            :visible-arrow="false"
            class="draggable-chip__popover-trigger"
            :class="{ 'is-popover-visible': popoverVisible }"
            v-model="popoverVisible"
          >
            <template #reference>
              <i class="icon-gear"></i>
            </template>
            <template #default>
              <div class="draggable-chip__popover-menu">
                <FormField label="Column type:">
                  <span class="draggable-chip__popover-highlight-item">{{ colData.type }}</span>
                </FormField>
                <FormField label="Filter type:">
                  <label
                    v-for="(option, i) in filterTypes"
                    :key="i"
                    :class="[{ active: option.value === filterType }]"
                    class="cta-constructor__radio"
                  >
                    <input
                      :value="option.value"
                      type="radio"
                      name="button"
                      class="cta-constructor__radio-input"
                      @input="
                        (e) =>
                          $emit('type-change', {
                            id: colData.id,
                            type: e.target.value
                          })
                      "
                    />
                    <div class="cta-constructor__radio-indicator"></div>
                    <p class="cta-constructor__radio-label">
                      <UiIcon :icon="option.icon" />
                      {{ option.label }}
                    </p>
                  </label>
                </FormField>
                <FormField v-if="filterType === 'range'" label="Step value">
                  <input
                    name="step"
                    :value="filterOptions ? filterOptions.step : 1"
                    type="number"
                    class="cta-constructor__input"
                    :disabled="!popoverVisible"
                    @blur="
                      (e) =>
                        $emit('step-change', {
                          id: colData.id,
                          step: e.target.value
                        })
                    "
                  />
                </FormField>
                <!-- <div class="cta-constructor__radio-wrap">
                    <h6 class="aside-field-label">Filter type</h6>
                  </div> -->
              </div>
            </template>
          </el-popover>
        </span>
      </div>
    </v-chip>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import UiIcon from '@/components/ui-icon'
import FormField from '@/components/form-field'
export default {
  name: 'DraggableChip',
  components: { draggable, UiIcon, FormField },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    hasSettings: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    colData: {
      type: Object
    },
    filterType: {
      type: String
    },
    filterOptions: {
      type: Object
    }
  },
  data() {
    return {
      popoverVisible: false,
      dragged: {
        from: -1,
        to: -1,
        newIndex: -1
      },
      filterTypes: [
        {
          label: 'Multiselect',
          value: 'multiple',
          icon: 'im-square-stack-lucide'
        },
        {
          label: 'Range Slider',
          value: 'range',
          icon: 'im-sliders-horizontal-phosphor'
        }
      ]
    }
  },
  computed: {
    dragOptionsChips() {
      return {
        animation: 200,
        group: 'group',
        disabled: false,
        ghostClass: 'ghost',
        sort: true
      }
    }
  },
  methods: {
    move: function (value) {
      this.dragged = {
        from: parseInt(value.from.id),
        to: parseInt(value.to.id),
        newIndex: value.draggedContext.futureIndex
      }
    },
    change: function (value) {
      const copy = [...this.value]
      if (value.removed) {
        // insert
        copy.splice(this.dragged.to + this.dragged.newIndex, 0, copy[this.dragged.from])
        // delete
        if (this.dragged.from < this.dragged.to) {
          copy.splice(this.dragged.from, 1)
        } else {
          copy.splice(this.dragged.from + 1, 1)
        }
      }
      this.$emit('input', copy)
    },
    onChipDeleteClick(index) {
      const copy = [...this.value]
      copy.splice(index, 1)

      this.$emit('input', copy)
    }
  }
}
</script>
